import { render } from "./MisFormularios.vue?vue&type=template&id=6b9474f5&scoped=true"
import script from "./MisFormularios.vue?vue&type=script&lang=js"
export * from "./MisFormularios.vue?vue&type=script&lang=js"

import "./MisFormularios.vue?vue&type=style&index=0&id=6b9474f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9474f5"]])

export default __exports__